import { API } from "../../Services";

export const trelloNewList = (id) =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_TRELLO_NEW_LIST",
        })
    
        API.trelloNewList(id).then((res)=>{
            console.log(res);
            let data = JSON.parse(JSON.stringify(res)).data
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_TRELLO_NEW_LIST",
                    payload:data,
                })
            },1000)
        }).catch((err)=>{
            dispatch({
                type:"ERROR_TRELLO_NEW_LIST",
            })
        })
    }
}